import Modal from "react-bootstrap/Modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import {useEffect, useRef, useState} from "react";
// -
import ModalCreateWaypoint from "./ModalCreateWaypoint";
import TableCheckboxWaypoints from "./TableCheckboxWaypoints";
import TableChoiceWaypoints from "./TableChoiceWaypoints";
import {WaypointModel} from "./WaypointModels";
import {toLowCaseCleanSpaces} from "core/utils/Texts";
import {publishEvent} from "core/eventsConnector";
import axiApi from "ApiCaller";

const ModalWaypointSelects = ({show, setShow, chosenIn = [], multiple = true, subtitle = ""}) => {
    const [item, setItem] = useState({...WaypointModel});

    const items = useRef({
        all: [],
        showed: [],
        chosen: [],
    });

    const [itemsShown, setItemsShown] = useState([]);
    const [showForm, setShowForm] = useState(false);

    useEffect(() => {
        if (!items.current.all.length) {
            axiApi.get(`/api/distribution/waypoints/`).then((resp) => {
                items.current.all = [...resp.data.items];
                items.current.chosen = [];
                items.current.showed = [...items.current.all];
                if (chosenIn.length) {
                    chosenIn.forEach((item) => {
                        const idx = items.current.all.findIndex((_item) => _item.id === item.id);
                        if (idx > -1) {
                            items.current.chosen.push(idx);
                        }
                    });
                }
                setItemsShown([...items.current.all]);
            });
        }
    }, []);

    const onSearch = (e) => {
        const valueSearched = toLowCaseCleanSpaces(e.target.value);
        if (valueSearched) {
            setItemsShown(items.current.all.filter((_item) => toLowCaseCleanSpaces(_item.name).includes(valueSearched)));
        } else {
            setItemsShown([...items.current.all]);
        }
    };

    const openFormCreateIslands = () => {
        setItem({...WaypointModel});
        setShowForm(true);
    };

    const handleClose = () => {
        setShow(false);
    };
    const handleAccept = () => {
        setShow(false);
        if (!items.current.chosen.length) return false;
        if (multiple) {
            let chosen = [];
            items.current.chosen.forEach((idx) => {
                chosen.push(items.current.showed[idx]);
            });
            publishEvent("waypoints:modal:selector", chosen);
        } else {
            publishEvent("waypoints:modal:selector", items.current.showed[items.current.chosen[0]]);
        }
    };

    return (
        <>
            {showForm ? (
                <ModalCreateWaypoint
                    showForm={showForm}
                    setShowForm={setShowForm}
                    setItemsShown={setItemsShown}
                    items={items}
                    item={item}
                />
            ) : (
                <> </>
            )}
            <Modal show={show && !showForm} onHide={handleClose} animation={true} scrollable={true}>
                <Modal.Header closeButton className="preview-canvas mb-0">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="fa-location-dot" />
                    </div>
                    <div className="preview-title d-inline-flex align-items-center">
                        <Modal.Title className="d-inline-flex ms-1">
                            <div>
                                <div className="h4 ms-0">Referencias</div>
                                <div className="h5 ms-0">
                                    <small>{subtitle}</small>
                                </div>
                            </div>
                        </Modal.Title>
                        <button className="btn btn-primary ms-5" onClick={openFormCreateIslands}>
                            <FontAwesomeIcon icon="fa-plus" />
                        </button>
                        <form className="d-inline-flex ms-2" role="search">
                            <input
                                className="form-control border-end-0 rounded-0"
                                type="search"
                                placeholder="Nombre"
                                aria-label="Search"
                                onChange={onSearch}
                            />
                            <span className="input-group-text bg-white border-start-0 rounded-0" id="modal-searcher-groups">
                                <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" />
                            </span>
                        </form>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    {multiple ? (
                        <TableCheckboxWaypoints items={items} itemsShown={itemsShown} setItem={setItem} />
                    ) : (
                        <TableChoiceWaypoints items={items} itemsShown={itemsShown} setItem={setItem} />
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Descartar
                    </Button>
                    <Button variant="primary" onClick={handleAccept}>
                        Seleccionar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ModalWaypointSelects;
